import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

class CurrenciesServices {
  // creating Currencies
    createCurrencies = async (payload) => {
      const createdCurrencies = await Helpers.post({
        url: Constants.CURRENCIES,
        data: payload,
      });
      return createdCurrencies;
    }

    // update Currencies

    updateCurrencies = async (payload) => {
      const updateCurrencies = await Helpers.put({
        url: Constants.CURRENCIES,
        data: payload,
      });
      return updateCurrencies;
    }

    // get Currencies

    getCurrencies = async (orgId) => {
      let url = `${Constants.CURRENCIES}?`;
      if (orgId) url += `org_id=${orgId}`;
      const Currencies = await Helpers.get({ url });
      return Currencies;
    }

    // delete Currencies

    deleteCurrencies = async (payload) => {
      const deletedCurrencies = await Helpers.delete({
        url: Constants.CURRENCIES,
        data: payload,
      });
      return deletedCurrencies;
    }

    // get latest currency

    getCurrencyConversionRate = async (payload) => {
      const { defaultCurrency } = payload;
      let url = `${Constants.CURRENCY_CONVERSION_RATE}?`;
      if (defaultCurrency) url += `base_currency=${defaultCurrency}`;
      const Currencies = await Helpers.get({ url });
      return Currencies;
    }

    // refresh latest currency

    refreshCurrencyConversionRate = async (payload) => {
      const Currencies = await Helpers.post({
        url: Constants.CURRENCY_CONVERSION_RATE,
        data: payload,
      });
      return Currencies;
    }
}

export default new CurrenciesServices();
